var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('emc-button-icon',{attrs:{"color":_vm.color,"icon":_vm.icon,"text":_vm.text},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }